'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./ToggleButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var ToggleButton = function ToggleButton(_ref) {
    var active = _ref.active;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('ToggleButton', { active: active }) },
        _react2.default.createElement('div', { className: 'toggle-thumb' })
    );
};

// Styles


ToggleButton.propTypes = {
    active: _propTypes2.default.bool
};

exports.default = ToggleButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/fields/ToggleButton.js
// module id = 1777
// module chunks = 0